import { createApp } from 'vue';
import App from './App.vue';

// Import the router and store
import router from '@/router';
import store from '@/store';
import { useThemeMode } from '@/composables/useThemeMode';
import { installLogBuffer } from '@/composables/useLogBuffer';

// Import the styles
import './assets/styles/input.css';
import './global.css';

// Import the Font Awesome icons
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faEdit, faSimCard, faRotate, faGripVertical, faDownload, faInfo, faSitemap, faUser, faBuilding, faBell, faLayerGroup, faShieldHalved } from '@fortawesome/free-solid-svg-icons';
import { faCircleQuestion} from '@fortawesome/free-regular-svg-icons';

// Font Awesome Icons
library.add(faEdit);
library.add(faSimCard);
library.add(faRotate);
library.add(faGripVertical);
library.add(faDownload);
library.add(faInfo);
library.add(faCircleQuestion);
library.add(faSitemap);
library.add(faUser);
library.add(faBuilding);
library.add(faBell);
library.add(faLayerGroup);
library.add(faShieldHalved);

// Install log buffer
installLogBuffer();

// Create app instance
const app = createApp(App);
const { initTheme } = useThemeMode();
initTheme();

// Register global components
app.component('font-awesome-icon', FontAwesomeIcon);

// Use plugins
app.use(store);
app.use(router);

// Mount the app
app.mount('#app');

// Register Service Worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.error('Service Worker registration failed:', err);
    });
  });
}

// Global storage for beforeinstallprompt event
window.deferredPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.deferredPrompt = e;
});
